/** Vehicle fuel pill. `fuel` comes from the adapter's `getFuel()`; null renders "—". */
export default function FuelPill({ fuel }) {
  if (!fuel) return <span className="text-on-surface-variant">—</span>;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full font-data-mono text-[11px] font-medium whitespace-nowrap ${
        fuel.highlighted ? 'bg-primary-fixed/40 text-on-primary-fixed' : 'bg-surface-container text-on-surface-variant'
      }`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${fuel.dotClass}`} aria-hidden="true" />
      {fuel.label}
    </span>
  );
}
